// removed by extract-text-webpack-plugin
module.exports = {"name-circle-container":"name-circle-container","name-bubble":"name-bubble","colorA":"colorA","colorB":"colorB","colorC":"colorC","colorD":"colorD","colorE":"colorE","colorF":"colorF","colorG":"colorG","colorH":"colorH","colorI":"colorI","colorJ":"colorJ","colorK":"colorK","colorL":"colorL","colorM":"colorM","colorN":"colorN","colorO":"colorO","colorP":"colorP","colorQ":"colorQ","colorR":"colorR","colorS":"colorS","colorT":"colorT","colorU":"colorU","colorV":"colorV","colorW":"colorW","colorX":"colorX","colorY":"colorY","colorZ":"colorZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/NameCircle/style.scss
// module id = K+jN
// module chunks = 0